import { create } from "zustand";

type TCaseFrameChatDocStore = {
  applyChatUpdate: ((content: string) => void) | null;
  setApplyChatUpdate: (applyChatUpdate: ((content: string) => void) | null) => void;
};

export const useCaseFrameChatDoc = create<TCaseFrameChatDocStore>((set) => ({
  applyChatUpdate: null,
  setApplyChatUpdate: (applyChatUpdate) => set({ applyChatUpdate })
}));
